// extracted by mini-css-extract-plugin
export default {"color-picker":"color-picker--a4n1SyUi","label":"label--RREphGDH","select":"select--XrpSL4TF","theme2Reset":"theme2Reset--icbYZhp3"};